"use client";

import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import { ButtonLink } from "@/components/ui/button";
import Image from "next/image";
import { useDetailSuccessData } from "../../hooks/useDetailSuccessData";

const SuccessHeader = () => {
  const t = useTranslations("success");
  const { title, image, name, qualification } = useDetailSuccessData();

  return (
    <div className={S.wrapper}>
      <div className={S.header}>
        <div className={S.headerText}>
          <ButtonLink href="/success-story" reverse arrow>
            {t("back")}
          </ButtonLink>
          <div className={S.textWrapper}>
            <h1 className={S.title}>{title}</h1>
            <div className={S.info}>
              <p className={S.infoName}>{name}</p> <p className={S.infoQualification}>{qualification}</p>
            </div>
          </div>
        </div>
        <Image width={800} height={600} alt={title} src={image} />
      </div>
    </div>
  );
};

export default SuccessHeader;
